import { useEffect } from 'react';

import { Market } from '@nf/types/odds';
import { OddsService } from '@nf/odds/services';

export const useUpdateMatch = (
	matchId: number, 
	updateMarkets: (updatedMarkets: Market[]) => void
) => {
	useEffect(() => {
		const oddsService = OddsService.getInstance();
		const subscription = oddsService.modelDirector.matchNotifier.onGetMatchMarkets(matchId).subscribe(data => {
			updateMarkets(data.markets);
		});

		return () => subscription.unsubscribe();
	}, [matchId, updateMarkets]);
};